// extracted by mini-css-extract-plugin
export default {"pageWrap":"mb-z","fullWidth":"nb-z","heading":"ob-z","fullBleed":"pb-z","hidden":"qb-z"};